import { defineMessages } from 'react-intl';

export const scope = 'app.components.InviteList';

export const messages = defineMessages({
  errCancelNotSaved: {
    id: `${scope}.errCancelNotSaved`,
    defaultMessage: "The invite wasn't cancelled. Please try again."
  },
});
